export default __webpack_public_path__ + "static/media/Maxdol-30-Inj-ban.127c7d5b.jpg";